import React from 'react';
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import StopShop from "../elements/service/StopShop";
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import Separator from "../elements/separator/Separator";
import { useTranslation } from "react-i18next";


const BonusReward = () => {
    const { t } = useTranslation('enterprise');
    return (
        <>
            <SEO title="N01ZET Comapny Entreprise Bonus Reward Prime Cash Vouchers Chèques-Cadeaux CSE" />
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" style={{height:"400px"}} data-black-overlay="1" >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner text-center">
                                    <h1 className="title display-one cust-title mt-5">{t('lePlan.gestionPrimes.subtitle')}</h1>
                                    <p className="description" style={{ fontSize: '20px' }}></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}

                {/* Start Description Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                            <p className='description b1'>{t('lePlan.gestionPrimes.pagecon1')}</p>
                            </div>
                        </div>    
                        <div className='row' style={{backgroundImage: "url('/images/nft/bonus.png')",backgroundRepeat:"no-repeat",backgroundPosition:"795px 140px",backgroundSize:'500px'}}>
                            <div className='col-lg-8'>
                                <div className='row'>
                                    <div className='col-lg-3'>
                                        <p className='description b1'>{t('lePlan.gestionPrimes.pagecon2')}</p>
                                        <p className='description b1'>{t('lePlan.gestionPrimes.pagecon3')}</p>
                                    </div>
                                    <div className='col-lg-9'>
                                        <img src={t('lePlan.gestionPrimes.cardSrc')} alt='process' className="stopshopimg" style={{width:"90%"}}/>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4'>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Description Area  */}

                <Separator />   
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="One-stop shop"
                                    description=""
                                />
                            </div>
                        </div>
                        <StopShop
                            serviceStyle="service__style--1 radius mt--20 rbt-border"
                            textAlign="text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default BonusReward
